import React, { useState, useEffect } from "react";

// react-router components
import { Route, Routes, useLocation /*, Navigate*/ } from "react-router-dom";
//import { Router, Route, Switch, Redirect } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "../components/MDBox";

// Material Dashboard 2 PRO React example components
import Sidenav from "../components/Sidenav";
import Configurator from "../components/Configurator";

// Material Dashboard 2 PRO React themes
import theme from "../assets/theme";

// Material Dashboard 2 PRO React Dark Mode themes
/*import themeDark from "./assets/theme-dark";*/

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator, setOpenBarraVertical } from "../context";

import { useTranslation } from 'react-i18next';

// core components
import Footer from "../components/Footer";

import { getCurrentRouteMain, getRoutesTienda } from "../routes.js";

import DashboardLayout from "../components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../components/Navbars/DashboardNavbar";

import logo from "../assets/img/logo_atm2x.png";

import { Helmet } from 'react-helmet'

export default function LayaoutAdmin() {
    const [controller, dispatch] = useMaterialUIController();
    const {
        miniSidenav,
        layout,
        openConfigurator,
        sidenavColor,
        transparentSidenav,
        whiteSidenav,
        darkMode,
    } = controller;

    const [onMouseEnter, setOnMouseEnter] = useState(false);
    const { pathname } = useLocation();

    // Open sidenav when mouse enter on mini sidenav
    const handleOnMouseEnter = () => {
        if (miniSidenav && !onMouseEnter) {
            setMiniSidenav(dispatch, false);
            setOnMouseEnter(true);
        }
    };

    // Close sidenav when mouse leave mini sidenav
    const handleOnMouseLeave = () => {
        if (onMouseEnter) {
            setMiniSidenav(dispatch, true);
            setOnMouseEnter(false);
        }
    };

    // Change the openConfigurator state
    const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
    
    // Setting page scroll to 0 when changing the route
    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
    }, [pathname]);

    const { t } = useTranslation();   
 
    const [loading, setLoading] = useState(true);
    const [image, setImage] = useState(null);
    const [imageUsuario, setImageUsuario] = useState(null);
    const [nameUsuario, setNameUsuario] = useState("");

    const [routes, setroutes] = useState([]);
    
    const [idoficinaselected, setidoficinaselected] = useState(-1);
    const [oficina, setoficina] = useState("");
    const [idRol, setidRol] = useState(-1);
    const [idUser, setidUser] = useState(-1);
    const [areaAgenda, setareaAgenda] = useState("");
    const [conincidencia, setconincidencia] = useState(false);
    const [conareaprivada, setconareaprivada] = useState(false);
    const [idoficinareserva, setidoficinareserva] = useState(0);
    const [loginmodoreserva, setloginmodoreserva] = useState(false);
    const [loginapps, setloginapps] = useState(false);    
    const [tipooficina, settipooficina] = useState(0);
    const [idpoitienda, setidpoitienda] = useState(0);
    const [gestionreservas, setgestionreservas] = useState(0);
    const [gestionencuestas, setgestionencuestas] = useState(0);
   
                            
    React.useEffect(() => {
        fetch('api/Data/GetCurrentUser')
            .then(response => response.json())
            .then(data =>
            {
                if (data != null)
                {
                    if (data != null && oficina != data.nameoficina || nameUsuario != data.userconected || idoficinaselected != data.idoficinaselected)
                    {
                        setidoficinaselected(data.idoficinaselected);
                        setNameUsuario(data.userconected);
                        setoficina(data.nameoficina);
                        setidRol(data.idRol);
                        setidUser(data.idUser)
                        setareaAgenda(data.areaAgenda); setconincidencia(data.conincidencia)
                        setconareaprivada(data.conareaprivada);
                        setidoficinareserva(data.idoficinareserva);
                        setloginmodoreserva(data.loginmodoreserva);
                        setloginapps(data.loginapps);
                        settipooficina(data.tipooficina);
                        setidpoitienda(data.idpoitienda);
                        setgestionreservas(data.gestionreservas);
                        setgestionencuestas(data.gestionencuestas);

                        //Rutas    
                        getCurrentRoute(data.userconected, data.idRol, data.idUser, data.areaAgenda, data.conincidencia, data.conareaprivada, data.loginmodoreserva, data.loginapps, data.tipooficina, data.gestionreservas, data.gestionencuestas, true);
                    }
                    else if (data != null && idpoitienda != data.idpoitienda)
                    {
                        setidpoitienda(data.idpoitienda);
                        getCurrentRoute(data.userconected, data.idRol, data.userconected, data.idUser, data.areaAgenda, data.conincidencia, data.conareaprivada, data.loginmodoreserva, data.loginapps, data.tipooficina, data.gestionreservas, data.gestionencuestas, true);
                    }

                    setLoading(false);
                }
                else
                    window.location.assign('/auth/login');
            }).catch(error => {
               // window.location.assign('/auth/login');
            });

    }, [loading]);

    React.useEffect(() => {
        //Si no estamos cargando la pagina
        if (!loading && nameUsuario != "") {
            //Si hay aplicacion guardadas indicamos las rutas actuales
           /* if (aplicaciones != null && aplicaciones.length > 0)
                getCurrentRoute(idRol, idUser, areaAgenda, conincidencia, conareaprivada, loginmodoreserva, loginapps, tipooficina, gestionreservas, gestionencuestas);                
            //sino, es que no tenemos los datos cargados, y por tanto inicializamos
            else
                setLoading(true);*/

            //Tratamos la sessiones
            getHaySessionUsuario();
        }

    });

    const getHaySessionUsuario = () => {

        fetch('api/Data/HaySessionUsuario')
            .then(response => response.json())
            .then(data => {
                if (data == null || (data != null && data < 0))
                    window.location.assign('/auth/login');
                else if (data != null && data > 0 && data != idoficinaselected)
                    setLoading(true);
            }).catch(error => {
            });
    }

    const getRoutes = (allRoutes) => {
        return allRoutes.map((route) => {
            //si es un item collapse hacemos route de los hijos
            if (route.collapse)
                return getRoutes(route.collapse);

            if (route.route) {

                /* return  <Route
                       path={route.path}
                       //component={prop.component}
                       //En lugar de pasarle el componente direcramente le paso el componente con nuevos parametros, en este caso literal, pero podria pasarle cualquiera-> ej campo={prop.rtlName}
                     render={(props) => <route.component {...props} literal={t} data={route.data} />}
                     key={route.key}
                   />
                   */
                //return <Route path={route.path} element={<route.component  />} key={route.key} />;
                //idRol={prop.idRol} idUser={prop.idUser} loginmodoreserva={prop.loginmodoreserva} loginapps={prop.loginapps} tipooficina={prop.tipooficina} idpoitienda={prop.idpoitienda} 

                return <Route path={route.path} element={route.component} key={route.key} />;
            }

            return null;
        });
    }

   
    const getCurrentRoute = (nameUser, idRol, idUser, areaAgenda, conincidencia, conareaprivada, loginmodoreserva, loginapps, tipooficina, gestionreservas, gestionencuestas, inicio) =>
    {
        //let idrutaactual = idroute;
        //let idrutanueva = idroute;
        let nuevaruta = routes;

        if (window.location.pathname.includes("/admin/dashtienda") || window.location.pathname.includes("/admin/tienda")) {
            nuevaruta = getRoutesTienda(t, nameUser, idRol, idUser, areaAgenda, conincidencia, conareaprivada, loginmodoreserva, loginapps, tipooficina, idpoitienda);
        }
        else {
            nuevaruta = getCurrentRouteMain(t, nameUser, idRol, idUser, areaAgenda, conincidencia, conareaprivada, loginmodoreserva, loginapps, tipooficina, gestionreservas, gestionencuestas);
        }

        if (inicio)
        {
            setroutes(nuevaruta);
            //setIdRoute(idrutanueva);
        }
    }

    const getBgImage = () =>
    {
        return logo;
    }     

    return (
        <ThemeProvider theme={/*darkMode ? themeDark :*/ theme}>
            <CssBaseline />
            <Helmet>
                <title>{"Aplicaciones Turisticas en Movilidad"}</title>
            </Helmet>
            {layout === "dashboard" && (
                <>
                    <Sidenav
                        color={sidenavColor}
                        brand={getBgImage() /*(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite*/}
                        brandName={"ATMovilidad"/*nameUsuario != null && nameUsuario != "" ? nameUsuario : ""*/}
                        routes={routes}
                        onMouseEnter={handleOnMouseEnter}
                        onMouseLeave={handleOnMouseLeave}
                    />       
                </>
            )}
            {/*layout === "vr" && <Configurator />*/}
            <DashboardLayout>
                <DashboardNavbar rutasactual={routes} oficina={oficina} idRol={idRol} loginmodoreserva={loginmodoreserva} loginapps={loginapps} />
                <Routes>
                    {getRoutes(routes)}
                </Routes>
                <MDBox mt={4}>
                    <Footer />
                </MDBox>
            </DashboardLayout>
        </ThemeProvider>
    );
}